<template>
  <section id="section__update" class="width-100">
    <v-row no-gutters>
      <v-col cols="12" class="px-2">
        <span class="font--m-3">{{ userStore.name }}</span>
      </v-col>

      <v-col cols="12">
        <Calendar @emitChangedDate="(v) => (selectedDate = v)"></Calendar>
      </v-col>

      <v-col cols="12" class="mb-5">
        <TodayDeposite :key="selectedDate + '_deposit'" :date="selectedDate"></TodayDeposite>
      </v-col>

      <v-col cols="12" class="mb-5">
        <SalesHistoryList :key="selectedDate + '_sales'" :date="selectedDate"></SalesHistoryList>
      </v-col>

      <v-col cols="12" class="mb-5">
        <DepositeDueList :key="selectedDate + '_due'" :date="selectedDate"></DepositeDueList>
      </v-col>

      <v-col cols="12">
        <BasicButton id="btn__z3W2tJ50C0aFqkvSSNuwtg" @click="alert">
          추가로 매출 당겨 받기!
        </BasicButton>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import Calendar from '@/components/settlement/Calendar.vue'
import TodayDeposite from '@/components/settlement/TodayDeposite.vue'
import SalesHistoryList from '@/components/settlement/SalesHistoryList.vue'
import DepositeDueList from '@/components/settlement/DepositeDueList.vue'

export default {
  components: {
    Calendar,
    TodayDeposite,
    SalesHistoryList,
    DepositeDueList,
  },
  data() {
    return {
      selectedDate: null,
    }
  },
  computed: {
    ...mapState('auth', ['me']),
    userStore() {
      return this.me?.store || {}
    },
  },
  mounted() {
    document.getElementsByTagName('article')[0].classList.add('fluid')
  },
  destroyed() {
    document.getElementsByTagName('article')[0].classList.remove('fluid')
  },
  created() {
    // update 제거
    this.$router.replace('/earlypay')
  },
  methods: {
    alert() {
      this.$swal.basic.alert({
        html: `다음 달에 미리 발생할 매출도 <br /> 미리 당겨드리는 '펀다나우' <br/><br/> 서비스 오픈을 준비하고 있어요!`,
      })
    },
  },
}
</script>
